/**
 * Utility function to extract error message from API response
 * Handles both message and errors array from backend
 */
export const extractErrorMessage = (error, defaultMessage = 'Ha ocurrido un error') => {
  const data = error.response?.data;
  let message = defaultMessage;
  
  if (data?.errors && Array.isArray(data.errors)) {
    // Handle validation errors array
    message = data.errors.map(err => err.msg || err.message).join(', ');
  } else if (data?.message) {
    // Handle single message
    message = data.message;
  }
  
  return message;
};

/**
 * Utility function to handle API errors with toast notification
 */
export const handleApiError = (error, defaultMessage = 'Ha ocurrido un error') => {
  const message = extractErrorMessage(error, defaultMessage);
  
  // Import toast dynamically to avoid circular dependencies
  import('react-hot-toast').then(({ toast }) => {
    toast.error(message);
  });
  
  return message;
}; 